// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3e320ed","732":"2026cbef","977":"0df1fc11"}[chunkId] + ".chunk.js";
};